import { makeActionCreator } from '../../../../../utilities'
import { WasPatientImmobilizedConstants } from './wasPatientImmobilized.constants'

export const setCollar = makeActionCreator(WasPatientImmobilizedConstants.SET_COLLAR, 'immCollar')
export const setCID = makeActionCreator(WasPatientImmobilizedConstants.SET_CID, 'immCid')
export const setLBB = makeActionCreator(WasPatientImmobilizedConstants.SET_LBB, 'immLbb')
export const setKED = makeActionCreator(WasPatientImmobilizedConstants.SET_KED, 'immKed')
export const setMAST = makeActionCreator(WasPatientImmobilizedConstants.SET_MAST, 'immMast')
export const setPerformedBy = makeActionCreator(WasPatientImmobilizedConstants.SET_PERFORMED_BY, 'immobBy')
export const setOutcome = makeActionCreator(WasPatientImmobilizedConstants.SET_OUTCOME, 'immobOutcome')
export const saveWasPatientImmobilized = makeActionCreator(WasPatientImmobilizedConstants.SAVE_WAS_PATIENT_IMMOBILIZED)
export const resetWasPatientImmobilized = makeActionCreator(WasPatientImmobilizedConstants.RESET_WAS_PATIENT_IMMOBILIED)
export const setWasPatientImmobilized = makeActionCreator(
  WasPatientImmobilizedConstants.SET_WAS_PATIENT_IMMOBILIED,
  'wasPatientImmobilized'
)
